import { PropertyType } from '@tallo/property';

export function isBedroomFieldRequired(propertyType: PropertyType | null | undefined) {
  return propertyType !== PropertyType.STUDIO;
}
